/* global femcare */

femcare.share.socialShare = {
    $socialShareBlock: $('.social-buttons-horizontal'),
    $articleAside: $('.article__share-icons'),

    init: function () {
        if (this.$socialShareBlock.length) {

            if (this.$articleAside.length) {
                this.addArticleAsideSocialButtons();
            }

            this.addEventHandlers();
        }
    },

    addArticleAsideSocialButtons: function () {
        var buttonsHtml = this.$socialShareBlock.find('.social-buttons').first().html();
        this.$articleAside.append(buttonsHtml);
    },

    addEventHandlers: function () {
        $('.share-button')
            .not("[data-channel='mail']")
            .on('click', function (e) {
                e.preventDefault();

                var $button = $(this);
                var url = $button.attr('href');
                window.open(url, 'share', 'width=640,height=320');
            });
    }
};
